package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.FlagSk: ImageVector
    get() {
        if (_flagSk != null) {
            return _flagSk!!
        }
        _flagSk = Builder(name = "FlagSk", defaultWidth = 512.0.dp, defaultHeight = 512.0.dp,
                viewportWidth = 512.0f, viewportHeight = 512.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFFEE1C25)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    lineTo(0.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF0B4EA2)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 341.3f)
                    lineTo(0.0f, 341.3f)
                    lineTo(0.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 170.7f)
                    lineTo(0.0f, 170.7f)
                    lineTo(0.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(203.2f, 395.5f)
                    curveTo(157.3f, 373.5f, 91.7f, 329.5f, 91.7f, 242.7f)
                    curveTo(91.7f, 155.9f, 95.8f, 116.5f, 95.8f, 116.5f)
                    lineTo(310.6f, 116.5f)
                    curveTo(310.6f, 116.5f, 314.8f, 155.9f, 314.8f, 242.7f)
                    curveTo(314.8f, 329.5f, 249.0f, 373.4f, 203.2f, 395.5f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFEE1C25)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(203.2f, 384.0f)
                    curveTo(161.1f, 363.7f, 100.9f, 323.5f, 100.9f, 243.8f)
                    curveTo(100.9f, 164.1f, 104.7f, 128.0f, 104.7f, 128.0f)
                    lineTo(301.7f, 128.0f)
                    curveTo(301.7f, 128.0f, 305.5f, 164.2f, 305.5f, 243.8f)
                    curveTo(306.111f, 310.222f, 256.828f, 363.797f, 203.2f, 384.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(212.2f, 223.0f)
                    curveTo(223.6f, 223.2f, 245.9f, 223.6f, 265.7f, 217.0f)
                    curveTo(265.7f, 217.0f, 265.1f, 224.0f, 265.1f, 232.3f)
                    curveTo(265.1f, 240.6f, 265.7f, 247.6f, 265.7f, 247.6f)
                    curveTo(248.292f, 242.804f, 230.238f, 240.779f, 212.2f, 241.6f)
                    lineTo(212.2f, 285.6f)
                    lineTo(194.2f, 285.6f)
                    lineTo(194.2f, 241.6f)
                    curveTo(176.162f, 240.779f, 158.108f, 242.804f, 140.7f, 247.6f)
                    curveTo(140.7f, 247.6f, 141.3f, 240.6f, 141.3f, 232.3f)
                    curveTo(141.3f, 232.3f, 140.7f, 217.0f, 140.7f, 217.0f)
                    curveTo(160.6f, 223.6f, 182.8f, 223.2f, 194.2f, 223.0f)
                    lineTo(194.2f, 195.3f)
                    curveTo(179.858f, 194.948f, 165.559f, 197.01f, 151.9f, 201.4f)
                    curveTo(151.9f, 201.4f, 152.4f, 194.4f, 152.4f, 186.1f)
                    curveTo(152.4f, 186.1f, 151.9f, 170.7f, 151.9f, 170.7f)
                    curveTo(168.9f, 176.4f, 183.8f, 176.9f, 194.1f, 176.7f)
                    curveTo(193.6f, 159.3f, 188.5f, 137.3f, 188.5f, 137.3f)
                    curveTo(188.5f, 137.3f, 199.0f, 138.1f, 203.2f, 138.1f)
                    curveTo(207.4f, 138.1f, 217.9f, 137.3f, 217.9f, 137.3f)
                    curveTo(217.9f, 137.3f, 212.8f, 159.3f, 212.2f, 176.8f)
                    curveTo(226.539f, 177.222f, 240.844f, 175.193f, 254.5f, 170.8f)
                    curveTo(254.5f, 170.8f, 254.0f, 177.8f, 254.0f, 186.1f)
                    curveTo(254.0f, 186.1f, 254.5f, 201.4f, 254.5f, 201.4f)
                    curveTo(237.5f, 195.7f, 222.6f, 195.3f, 212.2f, 195.4f)
                    lineTo(212.2f, 223.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF0B4EA2)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(203.2f, 280.8f)
                    curveTo(182.0f, 280.8f, 170.6f, 310.2f, 170.6f, 310.2f)
                    curveTo(170.6f, 310.2f, 164.3f, 296.2f, 147.0f, 296.2f)
                    curveTo(135.3f, 296.2f, 126.7f, 306.7f, 121.2f, 316.4f)
                    curveTo(142.5f, 350.2f, 176.5f, 371.1f, 203.2f, 384.0f)
                    curveTo(231.656f, 373.594f, 265.922f, 349.453f, 285.2f, 316.3f)
                    curveTo(279.7f, 306.7f, 271.1f, 296.3f, 259.4f, 296.3f)
                    curveTo(242.1f, 296.3f, 235.8f, 310.3f, 235.8f, 310.3f)
                    curveTo(235.8f, 310.3f, 224.4f, 280.8f, 203.2f, 280.8f)
                    close()
                }
            }
        }
        .build()
        return _flagSk!!
    }

private var _flagSk: ImageVector? = null
